import { render, staticRenderFns } from "./PropertySelector.vue?vue&type=template&id=8d212f62&"
import script from "./PropertySelector.vue?vue&type=script&lang=ts&"
export * from "./PropertySelector.vue?vue&type=script&lang=ts&"
import style0 from "./PropertySelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports